import { useSelector } from 'react-redux';
import { isMobile } from '../../authSlice/authSelectors';

function useIsMobileDevice(): boolean {
  return useSelector(isMobile);
}

export default useIsMobileDevice;
